import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bankingAccountsKeys } from "Api/Queries/Accounts/useBankingAccounts";
import { payPointKeys } from "Api/Queries/PayPoints/usePayPointQuery";
import {
  type BankAccountListItem,
  deleteBankingAccountsAccountID,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

export const useBankingAccountDelete = () => {
  const { t } = useResource();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (bankAccountID: BankAccountListItem["bankAccountID"]) =>
      processResponseWithApiProblemDetails(() =>
        deleteBankingAccountsAccountID(bankAccountID),
      )(),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: bankingAccountsKeys.all });
    },
    onSuccess: () => {
      toast.success(t(Resources.Hooks.BankingAccount.Deleted));
      //Invalidate Queries didn't work here, so we refetch directly
      queryClient.refetchQueries({
        queryKey: payPointKeys.all,
      });
    },
    onError: () => {
      toast.error(t(Resources.Hooks.BankingAccount.DeleteError));
    },
  });
};
